import {AppState} from '../reducer';
import {IFetchRoomProtection} from '../../incase-domain/rooms/room.player';
import {IRoomInfoModal} from '../actions/types/roomProtection.action.types';
import {TypedTranslation} from '../../i18n';

export const roomProtectionSelector = (state: AppState): IFetchRoomProtection | undefined => state.roomProtectionReducer.protection;
export const roomInfoModalSelector = (state: AppState): IRoomInfoModal => state.roomProtectionReducer.modal;
export const roomPasswordErrorSelector = (state: AppState): TypedTranslation | null => state.roomProtectionReducer.error;
